"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var alt_1 = require("../components/alt");
var UserActions = /** @class */ (function (_super) {
    tslib_1.__extends(UserActions, _super);
    function UserActions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserActions.prototype.setUser = function (user) {
        return user;
    };
    UserActions.prototype.setExperiment = function (experimentName, isEnabled) {
        var _a;
        return _a = {}, _a[experimentName] = isEnabled, _a;
    };
    return UserActions;
}(alt_1.AltActions));
exports.default = alt_1.default.createActions(UserActions);
//# sourceMappingURL=user_actions.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/user_actions.js
// module id = HLnu
// module chunks = 20 21 22